import { setCookie } from '../../aaa';
import Modal from 'react-bootstrap/Modal';
import PrimaryButton from '../../components/PrimaryButton';
import { Icon } from '@iconify/react';
import closeIcon from '@iconify/icons-material-symbols/close-rounded';
import cx from 'classnames';
import styles from './HowToUseModal.module.scss';
import libraryStyles from '../../SCSS/Library.module.scss';

interface Props {
  show: boolean;
  handleHideModal: () => void;
}

const HowToUseModal = ({ show, handleHideModal }: Props): JSX.Element => {
  const handleDoNotShowAgain = () => {
    setCookie('howToUseDistrictReporting', 'neverShowAgain');
    handleHideModal();
  };

  return (
    <Modal className={styles.howToUseModal} centered show={show}>
      <div className={styles.cancelButtonContainer} onClick={handleHideModal}>
        <Icon className={styles.cancelButton} icon={closeIcon} />
      </div>
      <div className={styles.content}>
        <h3>How to Use District Reporting</h3>
        <div className={styles.item}>
          <div>
            <Icon className={styles.infoGraphic} icon='prime:filter-fill' />
          </div>
          <p>
            <strong>Filtering: </strong>To display specific data on the graph, you can use the filter located at the top
            right. The following options are available for display: Number of Educators, Educator Logins, Student
            Logins, Story Opens, Lessons Access, and Time on Platform.
          </p>
        </div>
        <div className={styles.item}>
          <div>
            <Icon className={styles.infoGraphic} icon='material-symbols:calendar-month' />
          </div>
          <p>
            <strong>Date Range: </strong>To view data within specific time frames, use the date selector located at the
            top left. Choose the desired time frame using the date selector to adjust the data displayed on the graph
            accordingly.
          </p>
        </div>
        <div className={styles.item}>
          <div>
            <Icon className={styles.infoGraphic} icon='fa6-solid:school' />
          </div>
          <p>
            <strong>By School Reporting: </strong>View a breakdown of usage by all subscribed schools associated with
            the district.
          </p>
        </div>
      </div>
      <div className={styles.buttonsContainer}>
        <PrimaryButton small onClick={handleHideModal}>
          got it
        </PrimaryButton>
        <button onClick={handleDoNotShowAgain} className={cx(styles.doNotShowAgain, libraryStyles.textLink)}>
          Do not show me this again
        </button>
      </div>
    </Modal>
  );
};

export default HowToUseModal;
